export default __webpack_public_path__ + "static/media/1617 spice rack top.12c44166.png";